<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 14L14 3V10H20L10 21V14H4Z" stroke="#1B262C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
